module.exports = __webpack_public_path__ + "img/1048_help_title_c68071b06.png";